import { PaymentRowLayout } from "./PaymentRowLayout";
import React from "react";
import {
  CreditCardProgram,
  CreditPaymentProgram,
  PaymentStatus,
  PaymentType,
} from "../../../../constants/TransactionConstants";
import { ApplicationID } from "../../../../common/Constants";

export default function PaymentGeneralInformation(props) {
  const { transaction, paymentPasses, paymentCredit } = props;

  const isFullyPayPass = transaction.paymentType === PaymentType.Pass;
  const paymentMethod =
    CreditCardProgram.getName(paymentCredit.creditCardProgram) ||
    (isFullyPayPass
      ? paymentPasses?.map((x) => x.passProgramName).join(", ")
      : "");
  const passPaymentCodes = paymentPasses?.map((x) => x.passCode).join(", ");

  const processAmount = (transaction.processAmount ?? 0).toFixed(6);
  const finalAmount =
    transaction.salesChannel === ApplicationID.TPOS &&
    transaction.paymentType === PaymentType.Cash
      ? processAmount
      : transaction.amountFinal.toFixed(6);

  const paymentMethodName =
    transaction.paymentType === PaymentType.Credit ||
    transaction.paymentType === PaymentType.Pass
      ? `[${paymentMethod}]`
      : "";

  const paymentTypeName = PaymentType.getName(transaction.paymentType);

  const isGooglePay =
    transaction.paymentCredits?.[0]?.paymentProcessType ===
    CreditPaymentProgram.GooglePay;

  const firstCol = (
    <>
      {isGooglePay ? (
        <>
          {CreditPaymentProgram.getName(CreditPaymentProgram.GooglePay)} <br />
          Credit[Visa]
        </>
      ) : (
        <>
          {paymentTypeName} {paymentMethodName}
        </>
      )}
    </>
  );

  const creditMaskedNumberOrPassCode =
    paymentCredit.creditCardMaskedNumber ||
    (isFullyPayPass ? passPaymentCodes : "");

  const paymentFinalAmount =
    transaction.paymentStatus === PaymentStatus.Captured
      ? `$${finalAmount}`
      : "-";

  return (
    <PaymentRowLayout
      first={firstCol}
      second={creditMaskedNumberOrPassCode}
      third={paymentFinalAmount}
    />
  );
}
